import { Grid } from '@mui/material';

import DashboardCard from '~components/dashboard/DashboardCard';
import GalleryImage from '~components/dashboard/GallerySettingsCard/components/GalleryImage';
import ImageDropzone from '~components/inputs/ImageDropzone';
import { selectProjectGallery } from '~features/project-config/project-config.selectors';
import { deleteGalleryImage, uploadGalleryImage } from '~features/project-config/project-config.slice';
import useAppDispatch from '~hooks/useAppDispatch';
import useAppSelector from '~hooks/useAppSelector';
import type { ProjectGalleryType } from '~types/ProjectType';

const GallerySettingsCard = () => {
  const dispatch = useAppDispatch();
  const projectGallery: ProjectGalleryType = useAppSelector(selectProjectGallery);

  const onDropGalleryImage = (files: Array<File>) => {
    dispatch(uploadGalleryImage({ file: files[0], key: `project-gallery-${Math.floor(1000 * Math.random())}` }));
  };

  const onDeleteGalleryImage = (index: number) => {
    dispatch(deleteGalleryImage(index));
  };

  return (
    <DashboardCard
      title={'Gallery images'}
      subtitle={'Please upload main images that will be on your public minting page.'}
    >
      <Grid
        container
        gap={'20px'}
      >
        <Grid item>
          <ImageDropzone
            onDropFile={onDropGalleryImage}
            title={'New image'}
          />
        </Grid>
        {projectGallery.gallery.map((item: string, idx: number) => (
          <Grid
            item
            key={`gallery-image-${item.split('/').reverse()[0].split('.')[0]}`}
          >
            <GalleryImage
              url={item}
              onDelete={() => onDeleteGalleryImage(idx)}
            />
          </Grid>
        ))}
      </Grid>
    </DashboardCard>
  );
};

export default GallerySettingsCard;
